import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/new-transactions';
const URL = BASE_URL + '/new-transactions';

const getNewTransactionList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const createNewTransaction = async (data) => {
  try {
    const result = await axios.post(URL, data);
    return result.data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the new transaction.');
    }
  }
};

const updateNewTransaction = async (id, data) => {
  try {
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    console.log(error);
  }
};

const deleteNewTransaction = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getNewTransactionById = async (id) => {
  try {
    const result = await axios.get(`${URL}/${id}`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  getNewTransactionList,
  createNewTransaction,
  updateNewTransaction,
  deleteNewTransaction,
  getNewTransactionById,
};
